var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Aspect__ } from './Aspect__';
let Aspect_ = class Aspect_ extends React.PureComponent {
    render() {
        const { aspect } = this.props;
        let c;
        const structureAt = aspect.activeOf.structure;
        if (structureAt) {
            c = aspect.actor.actorRenderer.aspectifyJsxTemplate(structureAt.skeletonResultingFromAttachedTrait);
        }
        else {
            c = React.createElement(Aspect__, { ...this.props, key: "a" });
        }
        if (aspect.activeOf.wrapAspect) {
            c = aspect.aspectWrap.wrapAspect(c);
        }
        if (aspect.aspectCss.styleString) {
            c = (React.createElement(React.Fragment, null,
                React.createElement("style", { dangerouslySetInnerHTML: { __html: aspect.aspectCss.styleString } }),
                c));
        }
        return c;
    }
};
Aspect_ = __decorate([
    observer
], Aspect_);
export { Aspect_ };
